"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  zIndex: theme.zIndex.appBar,
  backgroundColor: theme.palette.primary.light,
  height: _constants.TOP_AREA_BANNER_HEIGHT
}));